import script from "./Select.vue?vue&type=script&lang=ts&setup=true"
export * from "./Select.vue?vue&type=script&lang=ts&setup=true"

import "./Select.vue?vue&type=style&index=0&id=5bf3b141&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf3b141"]])

export default __exports__